import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CircleQuestionFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM15.06 9.92C15.06 8.56 13.86 7.48 12.2 7.48C10.52 7.48 9.14 8.64 9.18 10.36H10.92C10.92 9.54 11.54 9.06 12.18 9.06C12.76 9.06 13.26 9.42 13.28 10.02C13.3 10.76 12.76 11.38 11.12 11.54V13.3H12.88V12.4C14.18 12.04 15.06 11.18 15.06 9.92ZM12 16.32C12.56 16.32 13.06 15.82 13.06 15.26C13.06 14.7 12.56 14.2 12 14.2C11.44 14.2 10.94 14.7 10.94 15.26C10.94 15.82 11.44 16.32 12 16.32Z" />
    </SvgIcon>
  );
});
